export default "__VITE_ASSET__CWFjyHUB__"